import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import styled from 'styled-components';
import { Icon } from '../icon';
import { chipConfig } from './utils';
export var ChipContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  // estilos generales\n  width: 100%;\n  max-width: max-content;\n  padding: ", " 8px;\n  background-color: ", ";\n\n  border: ", ";\n\n  border-radius: ", ";\n\n  // alineacion del contenido\n  display: flex;\n  align-items: center;\n"])), function (_ref) {
  var size = _ref.size;
  return chipConfig.padding[size];
}, function (_ref2) {
  var variant = _ref2.variant,
      color = _ref2.color,
      skin = _ref2.skin,
      theme = _ref2.theme;
  return variant === 'darken' && skin === 'outline' ? 'transparet' : chipConfig.skins[variant][color][skin].bg({
    theme: theme
  });
}, function (_ref3) {
  var variant = _ref3.variant,
      color = _ref3.color,
      skin = _ref3.skin,
      theme = _ref3.theme;
  return '1px solid ' + chipConfig.skins[variant][color][skin].border({
    theme: theme
  });
}, function (_ref4) {
  var size = _ref4.size;
  return size === 'small' ? '4px' : '8px';
});
export var Message = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  max-width: calc(224px - (", " * 2));\n  color: ", ";\n\n  // ellipsis\n  text-overflow: ellipsis;\n  overflow: hidden;\n  text-wrap: nowrap;\n"])), function (_ref5) {
  var size = _ref5.size;
  return chipConfig.padding[size];
}, function (_ref6) {
  var variant = _ref6.variant,
      color = _ref6.color,
      skin = _ref6.skin,
      theme = _ref6.theme;
  return variant === 'darken' && skin === 'fill' ? '#FFFF' : chipConfig.skins[variant][color][skin].textColor({
    theme: theme
  });
});
export var CustomIcon = styled(Icon)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-right: 4px;\n"])));